import { OrgReportScreen } from "../../features/org";

/** FS-15-06 기관 리포트 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/org */
export default function OrgReportPage() {
  return <OrgReportScreen />;
}
